import { AlertColor } from "@mui/material";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ToastState {
  showToast: boolean;
  message?: string;
  severity?: AlertColor;
}

const initialState: ToastState = {
  showToast: false,
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    resetToast: (state) => {
      state.showToast = initialState.showToast;
      state.message = initialState.message;
      state.severity = initialState.severity;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.showToast = true;
      state.message = action.payload;
      state.severity = "error";
    },
    setSuccess: (state, action: PayloadAction<string>) => {
      state.showToast = true;
      state.message = action.payload;
      state.severity = "success";
    },
    setInfo: (state, action: PayloadAction<string>) => {
      state.showToast = true;
      state.message = action.payload;
      state.severity = "info";
    },
    setWarning: (state, action: PayloadAction<string>) => {
      state.showToast = true;
      state.message = action.payload;
      state.severity = "warning";
    },
  },
  extraReducers: () => {},
});

export default toastSlice.reducer;
export const { resetToast, setError, setSuccess, setInfo, setWarning } =
  toastSlice.actions;
